import { render, staticRenderFns } from "./BackgroundOnlyLayout.vue?vue&type=template&id=203756ba&scoped=true"
import script from "./BackgroundOnlyLayout.vue?vue&type=script&lang=js"
export * from "./BackgroundOnlyLayout.vue?vue&type=script&lang=js"
import style0 from "./BackgroundOnlyLayout.vue?vue&type=style&index=0&id=203756ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203756ba",
  null
  
)

export default component.exports